import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { InventoryService } from './inventory.service';
import { Observable, combineLatest, map, take, tap } from 'rxjs';
import { Store } from '@ngrx/store';
import { PIMClassActions, selectPIMWatermark } from '@usf/ngrx-product';

@Injectable({
  providedIn: 'root',
})
export class InventoryLandingResolverService {
  constructor(
    private inventoryService: InventoryService,
    private store: Store,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state?: RouterStateSnapshot): any {
    return combineLatest([
      this.shouldUpdatePimData$(),
      this.inventoryService.inventoryStateIsLoaded$(),
    ]).pipe(
      take(1),
      tap(([shouldUpdatePimData, inventoryStateIsLoaded]) => {
        // If the state is loading, dont need to request the additional reload
        if (inventoryStateIsLoaded) {
          this.inventoryService.requestReload();
          this.inventoryService.loadCustomerMigrationData();
        }
        if (shouldUpdatePimData) {
          this.store.dispatch(PIMClassActions.load());
        }
      }),
    );
  }

  shouldUpdatePimData$(): Observable<boolean> {
    return this.store.select(selectPIMWatermark()).pipe(
      map(pimWatermark => {
        const wmDate = Date.parse(pimWatermark);
        //convert to hours
        return (Date.now() - wmDate) / (1000 * 60 * 60) >= 24;
      }),
    );
  }
}
